// COMPONENTS
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { PCCookieConsentForm } from "@picnicmedia/masanatemples123";
// FUNCTIONS
import { ShowCookieConsent } from "../functions/ShowCookieConsent";

export function CookieConsent() {
  const [showCookieConsent, setShowCookieConsent] = useState(true);

  function handleSubmit() {
    localStorage.setItem("cookieConsent", "concented");
    /**
     * HTL (19-07-23)
     * Remove Cookie consent form the DOC after 0.8s after user has given consent.
     */
    setTimeout(() => {
      setShowCookieConsent(false);
    }, 800);
  }

  useEffect(() => {
    const cookieConsent = ShowCookieConsent({ itemToGet: "cookieConsent" });
    setShowCookieConsent(cookieConsent);
  }, []);
  return (
    <div id="feature-cookieconsent">
      {showCookieConsent
        ? createPortal(
            <div className={`${showCookieConsent ? "CookieConsentSlideIn" : ""} cookie-consent-container fixed w-100`} style={{ bottom: 0, zIndex: 1200 }}>
              <PCCookieConsentForm ctaText="I Understand" handleSubmit={() => handleSubmit()}>
                <div className="flex flex-column">
                  <div className="text-size-3">This website uses cookies to improve user experience</div>
                  <div className="text-size-1">
                    Check out our{" "}
                    <a className="white underline" target="_blank" href="https://www.picnic.io/privacy">
                      Privacy Policy
                    </a>{" "}
                    for more info
                  </div>
                </div>
              </PCCookieConsentForm>
            </div>,
            document.body,
          )
        : null}
    </div>
  );
}
